import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "error"
}
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "button-container" }
const _hoisted_8 = { class: "file-label" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 0,
  class: "file-name"
}
const _hoisted_13 = {
  key: 1,
  class: "loading"
}
const _hoisted_14 = {
  key: 2,
  class: "response-container"
}
const _hoisted_15 = {
  key: 3,
  class: "error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_json_text = _resolveComponent("json-text")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.isAuthenticated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[5] || (_cache[5] = _createElementVNode("h1", null, "Вхід", -1)),
          (_ctx.loginError)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.loginError), 1))
            : _createCommentVNode("", true),
          _createElementVNode("form", {
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"])),
            class: "login-form"
          }, [
            _cache[4] || (_cache[4] = _createElementVNode("label", { for: "password" }, "Пароль:", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "password",
              id: "password",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event)),
              placeholder: "Введіть пароль",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.password]
            ]),
            _createElementVNode("button", {
              type: "submit",
              disabled: _ctx.isLoggingIn
            }, [
              (_ctx.isLoggingIn)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Вхід..."))
                : (_openBlock(), _createElementBlock("span", _hoisted_5, "Увійти"))
            ], 8, _hoisted_3)
          ], 32)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _cache[8] || (_cache[8] = _createElementVNode("h1", null, "Завантажити аудіо", -1)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, [
              _createElementVNode("input", {
                type: "file",
                onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args))),
                accept: ".mp3,.mp4,.mpeg,.mpga,.m4a,.wav,.webm,.aac,.flac"
              }, null, 32),
              _cache[6] || (_cache[6] = _createTextVNode(" Вибрати аудіофайл файл "))
            ]),
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.uploadAudio && _ctx.uploadAudio(...args))),
              disabled: _ctx.isLoading || !_ctx.audioFile
            }, [
              (_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Завантаження..."))
                : (_openBlock(), _createElementBlock("span", _hoisted_11, "Завантажити"))
            ], 8, _hoisted_9)
          ]),
          (_ctx.selectedFileName)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, " Обраний файл: " + _toDisplayString(_ctx.selectedFileName), 1))
            : _createCommentVNode("", true),
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Завантаження та обробка аудіо... "))
            : _createCommentVNode("", true),
          (_ctx.response)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _cache[7] || (_cache[7] = _createElementVNode("h2", null, "Відповідь сервера:", -1)),
                _createVNode(_component_json_text, { text: _ctx.response }, null, 8, ["text"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("p", null, "Помилка: " + _toDisplayString(_ctx.error), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}